module.exports = __webpack_public_path__ + "static/media/nodeInit1.5393bfc1.png";